<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客服工作站</el-breadcrumb-item>
        <el-breadcrumb-item>设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>首次绑定</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="card-row">
      <div class="card card01">
        <div
          class="card-row"
          style="font-size: 20px; font-weight: bold; margin-bottom: 2vh"
        >
          {{ info.name }}
        </div>
        <div class="card03" style="font-size: 14px">
          <div>
            性别：{{ info.sex === 1 ? "男" : info.sex === 2 ? "女" : "未填写" }}
          </div>
          <div>手机号码：{{ info.mobile }}</div>
        </div>
        <div class="card03" style="font-size: 14px">
          <div>年龄|生日：{{ info.age }}岁 / 未填写</div>
          <div>
            身高|体重：{{ info.height ? info.height : " " }}cm/{{
              info.weight ? info.weight : " "
            }}kg
          </div>
          <div>身份证号：{{ info.idCard }}</div>
        </div>
      </div>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      :page.sync="page"
      @on-load="onLoad"
      @row-update="updFisBind"
    >
      <template slot="menuLeft"> </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getFirstBind, updFisBind, getUserJkDetail } from "@/api/health/manage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      info: {},
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        viewBtn: false,
        editBtn: true,
        addBtn: false,
        delBtn: false,
        column: [
          {
            label: "客服首次电话",
            prop: "firstBindLabel1",
            type: "select",
            dicData: [
              { label: "未完成", value: 0 },
              { label: "已完成", value: 1 },
            ],
          },
          {
            label: "客服微信加好友",
            prop: "firstBindLabel2",
            type: "select",
            dicData: [
              { label: "未完成", value: 0 },
              { label: "已完成", value: 1 },
            ],
          },
          {
            label: "首次设备数据须知推送",
            prop: "firstBindLabel3",
            type: "select",
            dicData: [
              { label: "未完成", value: 0 },
              { label: "已完成", value: 1 },
            ],
          },
          {
            label: " 首次数据上传完成",
            prop: "firstBindLabel4",
            type: "select",
            dicData: [
              { label: "未完成", value: 0 },
              { label: "已完成", value: 1 },
            ],
          },
          {
            label: " 三天后健康模型建立消息推送",
            prop: "firstBindLabel5",
            type: "select",
            dicData: [
              { label: "未完成", value: 0 },
              { label: "已完成", value: 1 },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId;
      getFirstBind(wxUserId).then((res) => {
        console.log(res.data);
        this.data = res.data;
      });

      getUserJkDetail(wxUserId).then((res) => {
        this.info = res.data.userJk;
      });
    },

    updFisBind(row, index, done, loading) {
      console.log(row);
      updFisBind(row).then((res) => {
        done();
        this.onLoad(this.page);
        this.$message({
          type: "success",
          message: "修改成功!",
        });
      });
    },

    handleBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 10px;
}

.card {
  background: rgba(243, 235, 235, 0.884) 2F5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card01 {
  flex: 1;
  height: auto;
}

.card03 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}
</style>
